export default __webpack_public_path__ + "static/media/30.8fd8b268.jpg";